import React from "react";
import Header from "../layout/Header";
import CommunityHomeBanner from "../components/CommunityHomeBanner";
import CommunitySidbar from "../components/CommunitySidbar";
import Footer from "../layout/Footer";
import CommunitySidbarModal from "../components/CommunitySidbarModal";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../i18n"; // important to import
const CommunityHelpCenterTopic = () => {
  const { t } = useTranslation("CommunityHelpCenterTopic");

  return (
    <>
      <Header />
      <CommunityHomeBanner />
      <section>
        <div className="featured-courses-main">
          <div className="container">
            <div className="row featured-courses-row">
              <div className="col-md-4 col-lg-3 col-xl-2 d-none d-md-block">
                <CommunitySidbar />
              </div>
              <div className="col-md-8 col-lg-9 col-xl-10">
                <div className="row justify-content-center mb-4">
                  <div className="col-12 col-lg-11">
                    <div className="section-title col-md-12 col-lg-12 m-auto">
                      <div className="breadcrumb-main mt-4">
                        <nav aria-label="breadcrumb">
                          <ol className="breadcrumb align-items-center mb-3">
                            <li className="breadcrumb-item">
                              <Link to="" className="fw-400 fs-7">
                                {t("community")}
                              </Link>
                            </li>
                            <li className="breadcrumb-item">
                              <Link
                                to="/community-help"
                                className="fw-400 fs-7"
                              >
                                {t("helpcenter")}
                              </Link>
                            </li>
                            <li
                              className="breadcrumb-item fw-400 fs-7 active"
                              aria-current="page"
                            >
                              {t("helpcenter")} {t("topics")}
                            </li>
                          </ol>
                        </nav>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 d-flex justify-content-md-end justify-content-between align-items-center mb-4 mb-md-0">
                    <CommunitySidbarModal />
                  </div>
                </div>
                <div className="section-title col-md-12 col-lg-11 m-auto">
                  <div className="d-flex align-items-center gap-3 help-card mb-4">
                    <img
                      src="./community/help-center-1.png"
                      className=""
                      alt=""
                    />
                    <h2 className="text-start text-black my-0">
                      {t("accounteregistrationandlogin")}
                    </h2>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-md-12 col-lg-11">
                    <p className="fs-6 fw-400 text-muted">
                      {t("registrationinfo")}
                    </p>
                    <ul className="help-center-topic-list-1 w-100 bg-transparent ps-3">
                      <li className="topic-list pb-0">
                        {t("creatinganaccount")}
                        <ul className="help-center-topic-option gray-dots w-100 bg-transparent ps-4 mt-3">
                          <li className="text-muted">
                            {t("howtoregisternewac")}:
                          </li>
                          <p className="mb-0 text-muted">
                            {t("creatinganaccountdes1")}
                          </p>
                          <li className="text-muted">
                            {t("requiredinfoduringregistration")}
                          </li>
                          <p className="mb-0 text-muted">
                            {" "}
                            {t("creatinganaccountdes2")}
                          </p>
                          <li className="text-muted">
                            {t("accountverificationprocess")}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("creatinganaccountdes3")}
                          </p>
                        </ul>
                      </li>
                      <li className="topic-list pb-0">
                        {t("loggingin")}
                        <ul className="help-center-topic-option gray-dots w-100 bg-transparent ps-4 mt-3">
                          <li className="text-muted">
                            {t("howtolongintoyourac")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("loggingindes1")}
                          </p>
                          <li className="text-muted">
                            {t("toubleshootinglogiunissues")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("loggingindes2")}
                          </p>
                          <li className="text-muted">
                            {t("passwordresetandrecovery")}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("loggingindes3")}
                          </p>
                        </ul>
                      </li>
                      <li className="topic-list pb-0">
                        {t("accountsettings")}
                        <ul className="help-center-topic-option gray-dots w-100 bg-transparent ps-4 mt-3">
                          <li className="text-muted">
                            {t("updatingpersoninfo")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("accountsettingsdes1")}
                          </p>
                          <li className="text-muted">
                            {t("changingyourpassword")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("accountsettingsdes2")}
                          </p>
                          <li className="text-muted">
                            {t("managingemailprefrences")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("accountsettingsdes3")}
                          </p>
                        </ul>
                      </li>
                      <li className="topic-list pb-0">
                        {t("securityandprivacy")}
                        <ul className="help-center-topic-option gray-dots w-100 bg-transparent ps-4 mt-3">
                          <li className="text-muted">
                            {t("tipsforkeepingyourac")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("securityandprivacydes1")}
                          </p>
                          <li className="text-muted">
                            {t("privacysettingsandoptions")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("securityandprivacydes2")}
                          </p>
                          {/* <li className="text-muted">Two-factor authentication (2FA)</li> */}
                        </ul>
                      </li>
                      <li className="topic-list pb-0">
                        {t("accountdeactivationorclosure")}
                        <ul className="help-center-topic-option gray-dots w-100 bg-transparent ps-4 mt-3">
                          <li className="text-muted">
                            {t("howtodeactivateordeleteyouraccount")}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("accountdeactivationorclosuredes1")}
                          </p>
                          <li className="text-muted">
                            {t("implicationsofclosingyouraccount")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("accountdeactivationorclosuredes2")}
                          </p>
                          <li className="text-muted">
                            {t("dataretentionpolicies")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("accountdeactivationorclosuredes3")}
                          </p>
                        </ul>
                      </li>
                      <li className="topic-list pb-0">
                        {t("commonaccountissues")}
                        <ul className="help-center-topic-option gray-dots w-100 bg-transparent ps-4 mt-3">
                          <li className="text-muted">
                            {t("accountlockouts")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("commonaccountissuesdes1")}
                          </p>
                          <li className="text-muted">
                            {t("suspiciousactivityalerts")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("commonaccountissuesdes2")}
                          </p>
                          <li className="text-muted">
                            {t("unauthorizedaccessreports")}{" "}
                          </li>
                          <p className="mb-0 text-muted">
                            {t("commonaccountissuesdes3")}
                          </p>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default CommunityHelpCenterTopic;
